webpackJsonp([218116574192409],{

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _glamor = __webpack_require__(92);
	
	/*! normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css */
	
	/**
	 * 1. Change the default font family in all browsers (opinionated).
	 * 2. Correct the line height in all browsers.
	 * 3. Prevent adjustments of font size after orientation changes in
	 *    IE on Windows Phone and in iOS.
	 */
	
	/* Document
	   ========================================================================== */
	
	_glamor.css.insert('html {\n  font-family: sans-serif; /* 1 */\n  line-height: 1.15; /* 2 */\n  -ms-text-size-adjust: 100%; /* 3 */\n  -webkit-text-size-adjust: 100%; /* 3 */\n}');
	
	/* Sections
	   ========================================================================== */
	
	/**
	 * Remove the margin in all browsers (opinionated).
	 */
	
	_glamor.css.insert('body {\n  margin: 0;\n}');
	
	/**
	 * Add the correct display in IE 9-.
	 */
	
	_glamor.css.insert('article,\naside,\nfooter,\nheader,\nnav,\nsection {\n  display: block;\n}');
	
	/**
	 * Correct the font size and margin on `h1` elements within `section` and
	 * `article` contexts in Chrome, Firefox, and Safari.
	 */
	
	_glamor.css.insert('h1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}');
	
	/* Grouping content
	   ========================================================================== */
	
	/**
	 * Add the correct display in IE 9-.
	 * 1. Add the correct display in IE.
	 */
	
	_glamor.css.insert('figcaption,\nfigure,\nmain { /* 1 */\n  display: block;\n}');
	
	/**
	 * Add the correct margin in IE 8.
	 */
	
	_glamor.css.insert('figure {\n  margin: 1em 40px;\n}');
	
	/**
	 * 1. Add the correct box sizing in Firefox.
	 * 2. Show the overflow in Edge and IE.
	 */
	
	_glamor.css.insert('hr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}');
	
	/**
	 * 1. Correct the inheritance and scaling of font size in all browsers.
	 * 2. Correct the odd `em` font sizing in all browsers.
	 */
	
	_glamor.css.insert('pre {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}');
	
	/* Text-level semantics
	   ========================================================================== */
	
	/**
	 * 1. Remove the gray background on active links in IE 10.
	 * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.
	 */
	
	_glamor.css.insert('a {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}');
	
	/**
	 * Remove the outline on focused links when they are also active or hovered
	 * in all browsers (opinionated).
	 */
	
	_glamor.css.insert('a:active,\na:hover {\n  outline-width: 0;\n}');
	
	/**
	 * 1. Remove the bottom border in Firefox 39-.
	 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
	 */
	
	_glamor.css.insert('abbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}');
	
	/**
	 * Prevent the duplicate application of `bolder` by the next rule in Safari 6.
	 */
	
	_glamor.css.insert('b,\nstrong {\n  font-weight: inherit;\n}');
	
	/**
	 * Add the correct font weight in Chrome, Edge, and Safari.
	 */
	
	_glamor.css.insert('b,\nstrong {\n  font-weight: bolder;\n}');
	
	/**
	 * 1. Correct the inheritance and scaling of font size in all browsers.
	 * 2. Correct the odd `em` font sizing in all browsers.
	 */
	
	_glamor.css.insert('code,\nkbd,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}');
	
	/**
	 * Add the correct font style in Android 4.3-.
	 */
	
	_glamor.css.insert('dfn {\n  font-style: italic;\n}');
	
	/**
	 * Add the correct background and color in IE 9-.
	 */
	
	_glamor.css.insert('mark {\n  background-color: #ff0;\n  color: #000;\n}');
	
	/**
	 * Add the correct font size in all browsers.
	 */
	
	_glamor.css.insert('small {\n  font-size: 80%;\n}');
	
	/**
	 * Prevent `sub` and `sup` elements from affecting the line height in
	 * all browsers.
	 */
	
	_glamor.css.insert('sub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}');
	
	_glamor.css.insert('sub {\n  bottom: -0.25em;\n}');
	
	_glamor.css.insert('sup {\n  top: -0.5em;\n}');
	
	/* Embedded content
	   ========================================================================== */
	
	/**
	 * Add the correct display in IE 9-.
	 */
	
	_glamor.css.insert('audio,\nvideo {\n  display: inline-block;\n}');
	
	/**
	 * Add the correct display in iOS 4-7.
	 */
	
	_glamor.css.insert('audio:not([controls]) {\n  display: none;\n  height: 0;\n}');
	
	/**
	 * Remove the border on images inside links in IE 10-.
	 */
	
	_glamor.css.insert('img {\n  border-style: none;\n}');
	
	/**
	 * Hide the overflow in IE.
	 */
	
	_glamor.css.insert('svg:not(:root) {\n  overflow: hidden;\n}');
	
	/* Forms
	   ========================================================================== */
	
	/**
	 * 1. Change the font styles in all browsers (opinionated).
	 * 2. Remove the margin in Firefox and Safari.
	 */
	
	_glamor.css.insert('button,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: sans-serif; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n}');
	
	/**
	 * Show the overflow in IE.
	 * 1. Show the overflow in Edge.
	 */
	
	_glamor.css.insert('button,\ninput { /* 1 */\n  overflow: visible;\n}');
	
	/**
	 * Remove the inheritance of text transform in Edge, Firefox, and IE.
	 * 1. Remove the inheritance of text transform in Firefox.
	 */
	
	_glamor.css.insert('button,\nselect { /* 1 */\n  text-transform: none;\n}');
	
	/**
	 * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`
	 *    controls in Android 4.
	 * 2. Correct the inability to style clickable types in iOS and Safari.
	 */
	
	_glamor.css.insert('button,\nhtml [type="button"], /* 1 */\n[type="reset"],\n[type="submit"] {\n  -webkit-appearance: button; /* 2 */\n}');
	
	/**
	 * Remove the inner border and padding in Firefox.
	 */
	
	_glamor.css.insert('button::-moz-focus-inner,\n[type="button"]::-moz-focus-inner,\n[type="reset"]::-moz-focus-inner,\n[type="submit"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}');
	
	/**
	 * Restore the focus styles unset by the previous rule.
	 */
	
	_glamor.css.insert('button:-moz-focusring,\n[type="button"]:-moz-focusring,\n[type="reset"]:-moz-focusring,\n[type="submit"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}');
	
	/**
	 * Change the border, margin, and padding in all browsers (opinionated).
	 */
	
	_glamor.css.insert('fieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}');
	
	/**
	 * 1. Correct the text wrapping in Edge and IE.
	 * 2. Correct the color inheritance from `fieldset` elements in IE.
	 * 3. Remove the padding so developers are not caught out when they zero out
	 *    `fieldset` elements in all browsers.
	 */
	
	_glamor.css.insert('legend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}');
	
	/**
	 * 1. Add the correct display in IE 9-.
	 * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.
	 */
	
	_glamor.css.insert('progress {\n  display: inline-block; /* 1 */\n  vertical-align: baseline; /* 2 */\n}');
	
	/**
	 * Remove the default vertical scrollbar in IE.
	 */
	
	_glamor.css.insert('textarea {\n  overflow: auto;\n}');
	
	/**
	 * 1. Add the correct box sizing in IE 10-.
	 * 2. Remove the padding in IE 10-.
	 */
	
	_glamor.css.insert('[type="checkbox"],\n[type="radio"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}');
	
	/**
	 * Correct the cursor style of increment and decrement buttons in Chrome.
	 */
	
	_glamor.css.insert('[type="number"]::-webkit-inner-spin-button,\n[type="number"]::-webkit-outer-spin-button {\n  height: auto;\n}');
	
	/**
	 * 1. Correct the odd appearance in Chrome and Safari.
	 * 2. Correct the outline style in Safari.
	 */
	
	_glamor.css.insert('[type="search"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}');
	
	/**
	 * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.
	 */
	
	_glamor.css.insert('[type="search"]::-webkit-search-cancel-button,\n[type="search"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}');
	
	/**
	 * 1. Correct the inability to style clickable types in iOS and Safari.
	 * 2. Change font properties to `inherit` in Safari.
	 */
	
	_glamor.css.insert('::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}');
	
	/* Interactive
	   ========================================================================== */
	
	/*
	 * Add the correct display in IE 9-.
	 * 1. Add the correct display in Edge, IE, and Firefox.
	 */
	
	_glamor.css.insert('details, /* 1 */\nmenu {\n  display: block;\n}');
	
	/*
	 * Add the correct display in all browsers.
	 */
	
	_glamor.css.insert('summary {\n  display: list-item;\n}');
	
	/* Scripting
	   ========================================================================== */
	
	/**
	 * Add the correct display in IE 9-.
	 */
	
	_glamor.css.insert('canvas {\n  display: inline-block;\n}');
	
	/**
	 * Add the correct display in IE.
	 */
	
	_glamor.css.insert('template {\n  display: none;\n}');
	
	/* Hidden
	   ========================================================================== */
	
	/**
	 * Add the correct display in IE 10-.
	 */
	
	_glamor.css.insert('[hidden] {\n  display: none;\n}');

/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by BUCKLESCRIPT VERSION 3.1.5, PLEASE EDIT WITH CARE
	'use strict';
	
	var Theme = __webpack_require__(11);
	var React = __webpack_require__(1);
	var Config = __webpack_require__(76);
	var Helmet = __webpack_require__(77);
	var ReasonReact = __webpack_require__(7);
	var TypedGlamor = __webpack_require__(4);
	var CommonStyles = __webpack_require__(56);
	
	var html = "\n  <h1>Getting Published</h1>\n  <h2>Step 1: Provide good documentation and metadata</h2>\n\n  <h4>Readme</h4>\n  <p>\n    Add a file named <code>README.md</code> to the root of your project. A good\n    readme should at the very least answer the following questions:\n\n  <ul>\n    <li>What is it?\n    <li>What state is it in?\n    <li>How do I install it?\n    <li>How do I use it?\n  </ul>\n\n  <p>\n    Furthermore, providing an example, a change log and explaining how to contribute\n    is a bonus. And if it is a binding, please provide a link to the bound library,\n    as it usually provides more in-depth information and documentation.\n\n  <p>\n    NOTE: The readme and other metadata together must total less than 10k bytes\n    in order to be indexed by the search engine. To avoid going over that limit, \n    please keep the contents of the readme to only the essentials, and put\n    extensive documentation and such in a separate markdown file linked to from\n    the readme. This also has the added benefit of improving search relevance.,\n    making it easier to find your package when searching for relevant terms.\n\n  <h4>Metadata</h4>\n  <p>\n    Fill out the following fields in <code>package.json</code>:\n    <ul>\n      <li><em>description</em> - A short sentence describing the package\n      <li><em>license</em> - The <a href=\"https://spdx.org/licenses/\">SPDX License ID</a> of the package license\n      <li><em>keywords</em> - A list of keywords describing the package\n      <li><em>homepage</em> - The URL of the project homepage\n      <li><em>repository</em> - The URL of the source code repository\n      <li><em>bugs</em> - The URL of the bug tracker\n    </ul>\n\n  <p>\n    Additionally, a number of other factors are taken into account when calculating\n    a score for the package, which primarily is used as part of search result\n    ranking. This data is blatantly stolen from <a href=\"https://npms.io\">npms.io</a>,\n    who are nice enough to detail the factors taken into account\n    <a href=\"https://github.com/npms-io/npms-analyzer/blob/master/docs/architecture.md#evaluators\">here</a>.\n\n\n  <h2>Step 2: Publish to NPM (optional)</h2>\n  <p>\n    Follow the documentation on <a href=\"https://docs.npmjs.com/getting-started/publishing-npm-packages\">NPM</a>\n\n  <p>\n    Publishing to NPM is not a requirement. If your project is incomplete, experimental or otherwise not yet ready for primetime,\n    it might be easier to just depend on the master branch of the source code repository. You can still submit your\n    package to redex, where it'll then be marked as unpublished. This is not only intended as a warning, but also to\n    highlight opportunities to contribute. \n\n  <h2>Step 3: Submit to redex</h2>\n  <p>\n    Submitting published and unpublished packages both follow roughly the same process: Add the package to the appropriate\n    collection in <a href=\"https://github.com/redex/data/blob/master/sources.json\">sources.json</a> and\n    submit a PR. Or just <a href=\"https://github.com/redex/data/issues/new\">submit an issue</a> with the same information.\n\n    <h3>Published package</h3>\n    <p>\n      Add an entry in the published collection with the follwoing format:\n\n<pre><code>\"&lt;npm name&gt;\": {\n  \"category\": \"binding\" | \"library\" | \"tool\" | \"boilerplate\",\n  \"platforms\": [\"browser\" | \"node\" | \"native\" | \"any\"],\n  \"keywords\": [&lt;string&gt;]\n}</code></pre>\n\n    <h3>Unpublished package</h3>\n    <p>\n      Add an entry in the published collection with the follwoing format:\n\n<pre><code>\"&lt;owner&gt;/&lt;repository&gt;\": {\n  \"repository\": \"github:&lt;owner&gt;/&lt;repository&gt;\"\n  \"category\": \"binding\" | \"library\" | \"tool\" | \"boilerplate\",\n  \"platforms\": [\"browser\" | \"node\" | \"native\" | \"any\"],\n  \"keywords\": [&lt;string&gt;]\n}</code></pre>\n\n    Submissions are checked manually (with a little help from a linter script).\n    Any remarks will be noted in the PR. There's also a CI process that checks\n    <code>sources.json</code> for syntax and trivial errors, which will quickly\n    fail if you just made a silly mistake.\n\n  <h2>Frequently Asked Questions</h2>\n  <ul>\n    <li>\n      <h4>What does the \"neglected\" flag mean?</h4>\n      <p>\n        Packages that do not meet the minimum standards for documentation and\n        metadata, according to what's described in Step 1 above, are marked as\n        neglected. These packages might still function perfectly well, which is\n        why they're listed at all, but the quallity of the packaging is also often\n        a good indicator of the quality of its contents. There are therefore two\n        for having this, and to de-emphasize flagged packages:\n        <ol>\n          <li> When there are alternatives, it makes it easier for consumers to\n          make a choice by discarding packages that present themselves poorly and\n          make unnecessarily hard to make an informed choice.\n          <li> It serves as an incentive for package authors to improve the\n          presentation.\n        </ol>\n\n    <li>\n      <h4>Which keywords can I use?</h4>\n      <p>\n        Please try to use only the keywords that are already in use, which are\n        listed on the front page. If you don't think you package fits into any of\n        these categories, you may propose a new keyword in the submission PR. \n\n    <li>\n      <h4>What does the \"any\" platform mean?</h4>\n      <p>\n        The \"any\" platform means the package is platform-independent, because it\n        avoids using platform-specific features. It's improtant to distinguish\n        a package that is platform-independent from a package that, in one way or\n        another, targets all avilable platforms. These are not equivalent since a\n        platform-independent package will automatically support any new platform.\n  </ul>\n";
	
	var style = TypedGlamor.css( /* Some */[CommonStyles.html], /* :: */[TypedGlamor.backgroundColor(Theme.Panel[/* Color */0][/* background */0]),
	/* :: */[TypedGlamor.padding2(TypedGlamor.em(2), TypedGlamor.em(4)),
	/* :: */[TypedGlamor.select("@media (max-width: 900px)", /* :: */[TypedGlamor.padding2(TypedGlamor.em(1), TypedGlamor.em(2)),
	/* [] */0]),
	/* [] */0]]]);
	
	var component = ReasonReact.statelessComponent("Publish");
	
	function make() {
	  return (/* record */[
	    /* debugName */component[/* debugName */0],
	    /* reactClassInternal */component[/* reactClassInternal */1],
	    /* handedOffState */component[/* handedOffState */2],
	    /* willReceiveProps */component[/* willReceiveProps */3],
	    /* didMount */component[/* didMount */4],
	    /* didUpdate */component[/* didUpdate */5],
	    /* willUnmount */component[/* willUnmount */6],
	    /* willUpdate */component[/* willUpdate */7],
	    /* shouldUpdate */component[/* shouldUpdate */8],
	    /* render */function () {
	      return React.createElement("div", undefined, ReasonReact.element( /* None */0, /* None */0, Helmet.make( /* Some */[Config.titleTemplate("Publishing Guide")], /* None */0, /* None */0, /* None */0, /* array */[])), React.createElement("div", {
	        className: TypedGlamor.toString(style),
	        dangerouslySetInnerHTML: {
	          __html: html
	        }
	      }));
	    },
	    /* initialState */component[/* initialState */10],
	    /* retainedProps */component[/* retainedProps */11],
	    /* reducer */component[/* reducer */12],
	    /* subscriptions */component[/* subscriptions */13],
	    /* jsElementWrapped */component[/* jsElementWrapped */14]]
	  );
	}
	
	var $$default = ReasonReact.wrapReasonForJs(component, function () {
	  return make( /* array */[]);
	});
	
	exports.html = html;
	exports.style = style;
	exports.component = component;
	exports.make = make;
	exports.$$default = $$default;
	exports.default = $$default;
	exports.__esModule = true;
	/* style Not a pure module */

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by BUCKLESCRIPT VERSION 3.1.5, PLEASE EDIT WITH CARE
	'use strict';
	
	var Theme = __webpack_require__(11);
	var TypedGlamor = __webpack_require__(4);
	var GlobalStyles = __webpack_require__(85);
	
	var widthContainer = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.label("width-container"),
	/* :: */[TypedGlamor.margin2(TypedGlamor.zero, TypedGlamor.auto),
	/* :: */[TypedGlamor.maxWidth(TypedGlamor.px(960)),
	/* :: */[TypedGlamor.minWidth(TypedGlamor.px(359)),
	/* :: */[TypedGlamor.width(TypedGlamor.pct(100)),
	/* [] */0]]]]]);
	
	var html = TypedGlamor.css( /* None */0, /* :: */[TypedGlamor.select("& h1", /* :: */[TypedGlamor.fontSize(TypedGlamor.rem(2.25)),
	/* :: */[TypedGlamor.fontWeight(TypedGlamor.bold),
	/* :: */[TypedGlamor.lineHeight(TypedGlamor.em(1.1)),
	/* :: */[TypedGlamor.marginBottom(TypedGlamor.rem(1.45)),
	/* [] */0]]]]),
	/* :: */[TypedGlamor.select("& h2", /* :: */[TypedGlamor.fontSize(TypedGlamor.rem(1.62671)),
	/* :: */[TypedGlamor.fontWeight(TypedGlamor.bold),
	/* :: */[TypedGlamor.lineHeight(TypedGlamor.em(1.1)),
	/* :: */[TypedGlamor.marginBottom(TypedGlamor.rem(1.45)),
	/* [] */0]]]]),
	/* :: */[TypedGlamor.select("& h3", /* :: */[TypedGlamor.fontSize(TypedGlamor.rem(1.38316)),
	/* :: */[TypedGlamor.fontWeight(TypedGlamor.bold),
	/* :: */[TypedGlamor.lineHeight(TypedGlamor.em(1.1)),
	/* :: */[TypedGlamor.marginBottom(TypedGlamor.rem(1.45)),
	/* [] */0]]]]),
	/* :: */[TypedGlamor.select("& h1, & h2, & h3, & h4, & h5", /* :: */[TypedGlamor.select("& > a.anchor", /* :: */[TypedGlamor.marginLeft(TypedGlamor.px(-20)),
	/* :: */[TypedGlamor.paddingRight(TypedGlamor.px(4)),
	/* :: */[TypedGlamor.select("& > svg", /* :: */[TypedGlamor.visibility(TypedGlamor.hidden),
	/* [] */0]),
	/* [] */0]]]),
	/* :: */[TypedGlamor.hover( /* :: */[TypedGlamor.select("& > a.anchor > svg", /* :: */[TypedGlamor.visibility(TypedGlamor.visible),
	/* [] */0]),
	/* [] */0]),
	/* [] */0]]),
	/* :: */[TypedGlamor.select("& p", /* :: */[TypedGlamor.marginBottom(TypedGlamor.rem(1.45)),
	/* :: */[TypedGlamor.select("& *:last-child", /* :: */[TypedGlamor.marginBottom(TypedGlamor.zero),
	/* [] */0]),
	/* [] */0]]),
	/* :: */[TypedGlamor.select("& b, & strong", /* :: */[TypedGlamor.fontWeight(TypedGlamor.bold),
	/* [] */0]),
	/* :: */[TypedGlamor.select("& i, & em", /* :: */[TypedGlamor.fontStyle(TypedGlamor.italic),
	/* [] */0]),
	/* :: */[TypedGlamor.select("& ol, & ul", /* :: */[TypedGlamor.margin(TypedGlamor.zero),
	/* :: */[TypedGlamor.marginLeft(TypedGlamor.rem(1.45)),
	/* :: */[TypedGlamor.marginBottom(TypedGlamor.rem(1.45)),
	/* :: */[TypedGlamor.unsafe("listStylePosition", "outside"),
	/* :: */[TypedGlamor.unsafe("listStyleImage", "none"),
	/* [] */0]]]]]),
	/* :: */[TypedGlamor.select("& li", /* :: */[TypedGlamor.marginBottom(TypedGlamor.rem(1.45 / 2)),
	/* :: */[TypedGlamor.select("& > ol, & > ul", /* :: */[TypedGlamor.marginLeft(TypedGlamor.rem(1.45)),
	/* :: */[TypedGlamor.marginBottom(TypedGlamor.rem(1.45 / 2)),
	/* :: */[TypedGlamor.marginTop(TypedGlamor.rem(1.45 / 2)),
	/* [] */0]]]),
	/* :: */[TypedGlamor.select("& *:last-child", /* :: */[TypedGlamor.marginBottom(TypedGlamor.zero),
	/* [] */0]),
	/* :: */[TypedGlamor.select("& > p", /* :: */[TypedGlamor.marginBottom(TypedGlamor.rem(1.45 / 2)),
	/* [] */0]),
	/* [] */0]]]]),
	/* :: */[TypedGlamor.select("& ol", /* :: */[TypedGlamor.unsafe("listStyleType", "decimal"),
	/* :: */[TypedGlamor.select("& li", /* :: */[TypedGlamor.paddingLeft(TypedGlamor.zero),
	/* [] */0]),
	/* [] */0]]),
	/* :: */[TypedGlamor.select("& ul", /* :: */[TypedGlamor.unsafe("listStyleType", "disc"),
	/* :: */[TypedGlamor.select("& li", /* :: */[TypedGlamor.paddingLeft(TypedGlamor.zero),
	/* [] */0]),
	/* [] */0]]),
	/* :: */[TypedGlamor.select("& code", /* :: */[TypedGlamor.background(TypedGlamor.hsla(TypedGlamor.num(0), 0, 0, 0.04)),
	/* :: */[TypedGlamor.fontFamilies( /* :: */["'SFMono-Regular'",
	/* :: */["Consolas",
	/* :: */["'Roboto Mono'",
	/* :: */["'Droid Sans Mono'",
	/* :: */["'Liberation Mono'",
	/* :: */["Menlo",
	/* :: */["Courier",
	/* :: */["monospace",
	/* [] */0]]]]]]]]),
	/* :: */[TypedGlamor.fontSize(TypedGlamor.rem(0.85)),
	/* :: */[TypedGlamor.lineHeight(TypedGlamor.rem(1.45)),
	/* :: */[TypedGlamor.padding2(TypedGlamor.em(0.2), TypedGlamor.zero),
	/* [] */0]]]]]),
	/* :: */[TypedGlamor.select("& pre", /* :: */[TypedGlamor.marginBottom(TypedGlamor.rem(1.45)),
	/* :: */[TypedGlamor.fontSize(TypedGlamor.rem(0.85)),
	/* :: */[TypedGlamor.lineHeight(TypedGlamor.rem(1.42)),
	/* :: */[TypedGlamor.background(TypedGlamor.hsla(TypedGlamor.num(0), 0, 0, 0.04)),
	/* :: */[TypedGlamor.overflow(TypedGlamor.auto),
	/* :: */[TypedGlamor.unsafe("wordWrap", "normal"),
	/* :: */[TypedGlamor.padding(TypedGlamor.rem(1.45)),
	/* :: */[TypedGlamor.select("& code", /* :: */[TypedGlamor.background(TypedGlamor.none),
	/* :: */[TypedGlamor.lineHeight(TypedGlamor.em(1.42)),
	/* [] */0]]),
	/* [] */0]]]]]]]]),
	/* :: */[TypedGlamor.select("& a", /* :: */[TypedGlamor.color(Theme.Color[/* link */5]),
	/* :: */[TypedGlamor.textDecoration(TypedGlamor.none),
	/* :: */[TypedGlamor.hover( /* :: */[TypedGlamor.textDecoration(TypedGlamor.underline),
	/* [] */0]),
	/* [] */0]]]),
	/* :: */[TypedGlamor.select("& img", /* :: */[TypedGlamor.maxWidth(TypedGlamor.pct(100)),
	/* [] */0]),
	/* :: */[TypedGlamor.select("& .redex-codeblock.m-tabbed", /* :: */[TypedGlamor.display(TypedGlamor.flex),
	/* :: */[TypedGlamor.position(TypedGlamor.relative),
	/* :: */[TypedGlamor.select("& > ul", /* :: */[TypedGlamor.display(TypedGlamor.flex),
	/* :: */[TypedGlamor.position(TypedGlamor.absolute),
	/* :: */[TypedGlamor.flexDirection(TypedGlamor.column),
	/* :: */[TypedGlamor.margin(TypedGlamor.zero),
	/* :: */[TypedGlamor.opacity(0),
	/* :: */[TypedGlamor.transitions( /* :: */[
	/* tuple */[TypedGlamor.AnimatableProperty[/* opacity */76], TypedGlamor.ms(400), TypedGlamor.easeInOut, TypedGlamor.ms(200)],
	/* [] */0]),
	/* :: */[TypedGlamor.transforms( /* :: */[TypedGlamor.translateX(TypedGlamor.pct(-100)),
	/* [] */0]),
	/* :: */[TypedGlamor.height(TypedGlamor.pct(100)),
	/* :: */[TypedGlamor.select("& > li", /* :: */[TypedGlamor.cursor(TypedGlamor.pointer),
	/* :: */[TypedGlamor.margin(TypedGlamor.zero),
	/* :: */[TypedGlamor.display(TypedGlamor.inlineBlock),
	/* :: */[TypedGlamor.padding2(TypedGlamor.em(0.35), TypedGlamor.em(0.75)),
	/* :: */[TypedGlamor.color(TypedGlamor.white),
	/* :: */[TypedGlamor.textTransform(TypedGlamor.lowercase),
	/* :: */[TypedGlamor.fontVariant(TypedGlamor.smallCaps),
	/* :: */[TypedGlamor.select("&:not(.s-selected)", /* :: */[TypedGlamor.opacity(0.5),
	/* :: */[TypedGlamor.boxShadows( /* :: */[TypedGlamor.shadow(TypedGlamor.zero, TypedGlamor.px(-4), /* Some */[TypedGlamor.px(-2)], /* Some */[TypedGlamor.px(-2)], /* Some */[true], TypedGlamor.rgba(0, 0, 0, 0.1)),
	/* [] */0]),
	/* :: */[TypedGlamor.hover( /* :: */[TypedGlamor.opacity(1),
	/* [] */0]),
	/* [] */0]]]),
	/* :: */[TypedGlamor.select("&.reason", /* :: */[TypedGlamor.backgroundColor(Theme.Color[/* reason */8]),
	/* [] */0]),
	/* :: */[TypedGlamor.select("&.ml", /* :: */[TypedGlamor.backgroundColor(Theme.Color[/* ocaml */9]),
	/* [] */0]),
	/* [] */0]]]]]]]]]]),
	/* [] */0]]]]]]]]]),
	/* :: */[TypedGlamor.hover( /* :: */[TypedGlamor.select("& > ul", /* :: */[TypedGlamor.opacity(1),
	/* [] */0]),
	/* [] */0]),
	/* :: */[TypedGlamor.select("& > .codeblock", /* :: */[TypedGlamor.display(TypedGlamor.none),
	/* :: */[TypedGlamor.flex_(TypedGlamor.$$int(1)),
	/* :: */[TypedGlamor.maxWidth(TypedGlamor.pct(100)),
	/* :: */[TypedGlamor.select("&.s-selected", /* :: */[TypedGlamor.display(TypedGlamor.block),
	/* [] */0]),
	/* :: */[TypedGlamor.select("& > pre", /* :: */[TypedGlamor.marginTop(TypedGlamor.zero),
	/* :: */[TypedGlamor.select("&.lang-reason", /* :: */[TypedGlamor.borderLeft3(TypedGlamor.px(2), TypedGlamor.solid, Theme.Color[/* reason */8]),
	/* [] */0]),
	/* :: */[TypedGlamor.select("&.lang-ml", /* :: */[TypedGlamor.borderLeft3(TypedGlamor.px(2), TypedGlamor.solid, Theme.Color[/* ocaml */9]),
	/* [] */0]),
	/* [] */0]]]),
	/* [] */0]]]]]),
	/* [] */0]]]]]),
	/* [] */0]]]]]]]]]]]]]]]]);
	
	var _reset = GlobalStyles._reset;
	
	var _global = GlobalStyles._global;
	
	exports._reset = _reset;
	exports._global = _global;
	exports.widthContainer = widthContainer;
	exports.html = html;
	/* widthContainer Not a pure module */

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	// Generated by BUCKLESCRIPT VERSION 3.1.5, PLEASE EDIT WITH CARE
	'use strict';
	
	var Theme = __webpack_require__(11);
	var TypedGlamor = __webpack_require__(4);
	
	__webpack_require__(91);
	
	TypedGlamor.$$global("*", /* :: */[TypedGlamor.unsafe("boxSizing", "border-box"),
	/* [] */0]);
	
	TypedGlamor.$$global("*:focus", /* :: */[TypedGlamor.outlineStyle(TypedGlamor.none),
	/* [] */0]);
	
	TypedGlamor.$$global("body", /* :: */[TypedGlamor.lineHeight(TypedGlamor.inherit_),
	/* :: */[TypedGlamor.color(Theme.Color[/* text */4]),
	/* [] */0]]);
	
	TypedGlamor.$$global("h1, h2, h3", /* :: */[TypedGlamor.lineHeight(TypedGlamor.em(1.1)),
	/* :: */[TypedGlamor.fontWeight(TypedGlamor.normal),
	/* [] */0]]);
	
	TypedGlamor.$$global("a", /* :: */[TypedGlamor.color(TypedGlamor.inherit_),
	/* [] */0]);
	
	TypedGlamor.$$global("button, input, select", /* :: */[TypedGlamor.background(TypedGlamor.none),
	/* :: */[TypedGlamor.border(TypedGlamor.none),
	/* :: */[TypedGlamor.font(TypedGlamor.inherit_),
	/* [] */0]]]);
	
	TypedGlamor.$$global("button::-moz-focus-inner", /* :: */[TypedGlamor.outline(TypedGlamor.none),
	/* [] */0]);
	
	var _reset = TypedGlamor.$$global("ol, ul", /* :: */[TypedGlamor.unsafe("listStyle", "none"),
	/* :: */[TypedGlamor.margin(TypedGlamor.zero),
	/* :: */[TypedGlamor.padding(TypedGlamor.zero),
	/* [] */0]]]);
	
	TypedGlamor.$$global("html", /* :: */[TypedGlamor.fontSize(TypedGlamor.px(15)),
	/* :: */[TypedGlamor.lineHeight(TypedGlamor.em(1.25)),
	/* :: */[TypedGlamor.fontFamilies( /* :: */["-apple-system",
	/* :: */["BlinkMacSystemFont",
	/* :: */["Segoe UI",
	/* :: */["Roboto",
	/* :: */["Oxygen",
	/* :: */["Ubuntu",
	/* :: */["Cantarell",
	/* :: */["Fira Sans",
	/* :: */["Droid Sans",
	/* :: */["Helvetica Neue",
	/* :: */["sans-serif",
	/* [] */0]]]]]]]]]]]),
	/* :: */[TypedGlamor.unsafe("boxSizing", "border-box"),
	/* :: */[TypedGlamor.unsafe("overflowY", "scroll"),
	/* [] */0]]]]]);
	
	var _global = TypedGlamor.$$global("html, body, #___gatsby", /* :: */[TypedGlamor.backgroundColor(Theme.Color[/* background */2]),
	/* :: */[TypedGlamor.minHeight(TypedGlamor.pct(100)),
	/* [] */0]]);
	
	exports._reset = _reset;
	exports._global = _global;
	/*  Not a pure module */

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-publish-js-aff0df0a636c275a8398.js